import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, effect } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import { PatientBehaviorAntecedentModel, PatientBehaviorConsequenceModel, PatientBehaviorDataModel, PatientBehaviorLocationModel, PatientBehaviorModel, PatientBehaviorResponseModel, PatientBehaviorSeverityModel, PatientBehaviorType } from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { AlertService } from '../../../shared/services/alert.service';
@Component({
  selector: 'app-abc-data-panel',
  templateUrl: './abc-data-panel.component.html',
  standalone: false,
})
export class ABCDataPanelComponent  {
  @Input() behaviorID: number = 0;
  @Input() sessionValue: number = 0;
  @Input() behaviorType: PatientBehaviorType = PatientBehaviorType.Frequency;
  behaviorData: PatientBehaviorDataModel[] = [];

  editingABCData?: PatientBehaviorDataModel;
  editingABCDataOriginalRecordedDate?: string;
  abcData: PatientBehaviorDataModel[] = [];
  isOtherAntecedentSelected: boolean = false;
  isOtherConsequenceSelected: boolean = false;

  patientBehaviorLocations: PatientBehaviorLocationModel[] = [];
  patientBehaviorConsequences: PatientBehaviorConsequenceModel[] = [];
  patientBehaviorResponses: PatientBehaviorResponseModel[] = [];
  patientBehaviorSeverities: PatientBehaviorSeverityModel[] = [];
  patientBehaviorAntecedents: PatientBehaviorAntecedentModel[] = [];
  patientBehaviors: PatientBehaviorModel[] = [];

  @Output() setExtraBoxesEvent = new EventEmitter<any>();

  constructor(
    protected cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    private alertService: AlertService
  ) {
    effect(() => {
      this.patientSessionService.dataChanged();
      const behaviorData = this.patientSessionService.getBehaviorData(this.behaviorID);
      if (behaviorData && behaviorData.length > 0) {
        this.behaviorData = behaviorData.filter(b => !b.DeletedDate);
        var lastLength = this.abcData.length;
        this.abcData = this.behaviorData;
        if (!this.editingABCData || this.abcData.length > lastLength) {
          this.editingABCData = this.abcData[this.abcData.length - 1];
          this.editingABCDataOriginalRecordedDate = this.editingABCData?.RecordedDate;
        }
        this.selectedEditingABCData();
        setTimeout(() => {
            //scroll tabs to end
            const tabs = document.querySelectorAll('.abc-tabs');
            tabs.forEach(tab => {
              tab.scrollLeft = tab.scrollWidth;
            });
          }, 100);
      }
      else {
        this.behaviorData = [];
        this.abcData = [];
      }
    });

    effect(() => {
      this.patientBehaviorLocations = this.patientSessionService.getPatientBehaviorLocations();
    });
    effect(() => {
      this.patientBehaviorResponses = this.patientSessionService.getPatientBehaviorResponses();
    });
    effect(() => {
      this.patientBehaviorSeverities = this.patientSessionService.getPatientBehaviorSeverities();
    });
    effect(() => {
      this.patientBehaviors = this.patientSessionService.getPatientBehaviors();
    });
    
    effect(() => {
      this.patientBehaviorConsequences = this.patientSessionService.getPatientBehaviorConsequences();
      if (!this.patientBehaviorConsequences.find(c => c.ID === -1)) {
        this.patientBehaviorConsequences.push({
          ID: -1,
          PatientBehaviorConsequence: 'Other'
        });
      }
    });
    
    effect(() => {
      this.patientBehaviorAntecedents = this.patientSessionService.getPatientBehaviorAntecedents();
      if (!this.patientBehaviorAntecedents.find(a => a.ID === -1)) {
      this.patientBehaviorAntecedents.push({
        ID: -1,
        PatientBehaviorAntecedent: 'Other'
        });
      }
    });
  }


  selectTab(data: PatientBehaviorDataModel): void {
    this.editingABCData = data;
    this.editingABCDataOriginalRecordedDate = data.RecordedDate;
    this.selectedEditingABCData();
  }

  selectedEditingABCData(){
    this.isOtherAntecedentSelected = !!this.editingABCData?.PatientBehaviorAntecedentOther || (!!this.editingABCData?.PatientBehaviorAntecedentIDs?.find(id => id === -1));
    this.isOtherConsequenceSelected = !!this.editingABCData?.PatientBehaviorConsequenceOther || (!!this.editingABCData?.PatientBehaviorConsequenceIDs?.find(id => id === -1));
    if (this.isOtherAntecedentSelected && this.editingABCData?.PatientBehaviorAntecedentIDs) {
      // add -1 to the list if it is not already there
      if (!this.editingABCData.PatientBehaviorAntecedentIDs.find(id => id === -1)) {
        this.editingABCData.PatientBehaviorAntecedentIDs.push(-1);
      }
    }
    if (this.isOtherConsequenceSelected &&  this.editingABCData && this.editingABCData.PatientBehaviorConsequenceIDs) {
      //add -1 to the list if it is not already there
      if (!this.editingABCData.PatientBehaviorConsequenceIDs.find(id => id === -1)) {
        this.editingABCData.PatientBehaviorConsequenceIDs.push(-1);
      }
    }

    if (this.editingABCData && !this.editingABCData.OtherPatientBehaviorIDs){
        this.editingABCData.OtherPatientBehaviorIDs = [];
    }
    if (this.editingABCData?.OtherPatientBehaviorIDs && !this.editingABCData.OtherPatientBehaviorIDs.find(id => id === this.behaviorID)) {
    this.editingABCData.OtherPatientBehaviorIDs.push(this.behaviorID);
    }
  }

  isDurationBehavior(): boolean {
    return this.behaviorType === PatientBehaviorType.Duration || this.behaviorType === PatientBehaviorType.Interval || this.behaviorType === PatientBehaviorType.RateTimer;
  }

  getDurationTimeRangeString(data: PatientBehaviorDataModel): string {
    //from date is the recorded date and to data is the recorded data plus the intVBalue in seconds
    const fromDate = new Date(data.RecordedDate ?? '');
    const toDate = new Date(fromDate.getTime() + (data.IntValue ?? 0) * 1000);
    return this.formatDate(fromDate,false) + ' - ' + this.formatDate(toDate,false);
  }

  formatDateFromString(date: string): string {
    return this.formatDate(new Date(date),true);
  }

  formatDate(date: Date, includePrefix: boolean = true): string {
    const today = new Date();
    if (date.toDateString() === today.toDateString()) {
      return (includePrefix ? 'at ' : '') + date.toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toLowerCase();
    } else {
      return (includePrefix ? 'on ' : '') + date.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: '2-digit'
      });
    }
  }

  addIntervalABCData( interval: { ID?: number, happened: boolean, RecordedDate: string, FormattedDate: string }): void {
    this.initializeABCData(interval.RecordedDate);
  }

  addRateABCData(rate: { ID?: number, rate: number, RecordedDate: string, FormattedDate: string }): void {
    this.initializeABCData(rate.RecordedDate);
  }

  addTimeABCData(time: { ID?: number, Text: string, Duration: number, RecordedDate: string, FormattedDate: string }): void {
    this.initializeABCData(time.RecordedDate);
  }

  addABCData(): void {
    let behaviorData: PatientBehaviorDataModel = {
      TextValue: this.sessionValue.toString(),
      IntValue: this.sessionValue,
      PatientSessionID: 0,
      PatientBehaviorID: this.behaviorID,
      RecordedDate: new Date().toServerString(),
      OtherPatientBehaviorIDs: [this.behaviorID],
      PatientBehaviorAntecedentIDs: [],
      PatientBehaviorConsequenceIDs: [],
      PatientBehaviorResponseID: 0,
      PatientBehaviorSeverityID: 0,
      PatientBehaviorLocationID: 0,
      Notes: ' '
    };
    this.patientSessionService.addBehaviorData(behaviorData);
  }

  initializeABCData(recordedDate: string): void {
    const behaviorData = this.behaviorData.find(data => data.RecordedDate === recordedDate);
    if (!behaviorData) {
      return;
    }

    if (behaviorData.Notes == null) {
      behaviorData.Notes = ' ';
    }
    if (!behaviorData.OtherPatientBehaviorIDs) {
      behaviorData.OtherPatientBehaviorIDs = [this.behaviorID];
    }
    if (!behaviorData.PatientBehaviorAntecedentIDs) {
      behaviorData.PatientBehaviorAntecedentIDs = [];
    }
    if (!behaviorData.PatientBehaviorConsequenceIDs) {
      behaviorData.PatientBehaviorConsequenceIDs = [];
    }
    if (behaviorData.PatientBehaviorResponseID == null) {
      behaviorData.PatientBehaviorResponseID = 0;
    }
    if (behaviorData.PatientBehaviorSeverityID == null) {
      behaviorData.PatientBehaviorSeverityID = 0;
    }
    if (behaviorData.PatientBehaviorLocationID == null) {
      behaviorData.PatientBehaviorLocationID = 0;
    }

    this.patientSessionService.saveBehaviorData(behaviorData, recordedDate);
  }

  changedBehaviors(): void {
    //Check if this behaviorID was excluded and include it again
    if (this.editingABCData?.OtherPatientBehaviorIDs && !this.editingABCData.OtherPatientBehaviorIDs.find(id => id === this.behaviorID)) {
      this.editingABCData.OtherPatientBehaviorIDs.push(this.behaviorID);
    }
    this.changedABCData();
  }

  changedAntecedent(): void {
    if (this.editingABCData?.PatientBehaviorAntecedentIDs && this.editingABCData.PatientBehaviorAntecedentIDs.find(id => id === -1)) {
      this.isOtherAntecedentSelected = true;
    } else {
      this.isOtherAntecedentSelected = false;
      this.editingABCData && (this.editingABCData.PatientBehaviorAntecedentOther = '');
    }
    this.changedABCData();
  }

  changedConsequences(): void {
    if (this.editingABCData?.PatientBehaviorConsequenceIDs && this.editingABCData.PatientBehaviorConsequenceIDs.find(id => id === -1)) {
      this.isOtherConsequenceSelected = true;
    } else {
      this.isOtherConsequenceSelected = false;
      this.editingABCData && (this.editingABCData.PatientBehaviorConsequenceOther = '');
    }
    this.changedABCData();
  }

  changedABCData(): void {
    if (this.editingABCData) {
      this.patientSessionService.saveBehaviorData(this.editingABCData, this.editingABCDataOriginalRecordedDate);
      this.editingABCDataOriginalRecordedDate = this.editingABCData.RecordedDate;
    }
  }

  getEditingABCRecordedDate(): string {
    return this.editingABCData?.RecordedDate?.slice(0, 16) ?? '';
  }

  changedRecordedDate(recordedDate: string): void {
    if (!this.editingABCData || !recordedDate) {
      return;
    }

    this.editingABCData.RecordedDate = recordedDate.length === 16 ? recordedDate + ':00' : recordedDate.slice(0, 19);
    this.changedABCData();
  }

  setExtraBoxes(): void {
    this.setExtraBoxesEvent.emit();
  }

  public setLastEditingABCData(): void {
    this.editingABCData = this.abcData[this.abcData.length - 1];
    this.editingABCDataOriginalRecordedDate = this.editingABCData?.RecordedDate;
    setTimeout(() => {
        //scroll tabs to end
        const tabs = document.querySelectorAll('.abc-tabs');
        tabs.forEach(tab => {
          tab.scrollLeft = tab.scrollWidth;
        });
      }, 100);
  }

  public clearEditingABCData(): void {
    this.editingABCData = undefined;
    this.editingABCDataOriginalRecordedDate = undefined;
  }

  public setEditingABCData(recordedDate: string): void {
    this.editingABCData = this.abcData.find(data => data.RecordedDate === recordedDate);
    this.editingABCDataOriginalRecordedDate = this.editingABCData?.RecordedDate;
    this.selectedEditingABCData();
  }

  deleteABC(data: PatientBehaviorDataModel): void {
    //confirm the deletion
    const confirmed = this.alertService.confirm('Are you sure you want to delete this ABC data?', 'Delete ABC Data');
    confirmed.subscribe((result: boolean) => {
      if (result) {
        data.DeletedDate = new Date().toServerString();
        this.patientSessionService.saveBehaviorData(data);
      }
    });
  }
}
